<template>
  <MetricTimeSeries
    :title="title"
    :item-id="itemId"
    :operation="operation"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTimeSeries from '@/components/cards/MetricTimeSeries';
import { OPERATION } from '@/services/charts-service';

export default {
  name: 'PostInTime',
  components: {
    MetricTimeSeries,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    operation() {
      return OPERATION.COUNT;
    },
  },
};
</script>
